/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const sendPdfReport = `mutation GenerateEventReport($input: ReportInput!) {
    sendPdfReport(input: $input)
  }
  `;
